import AccessPointIcon from "mdi-react/AccessPointIcon";
import AccessPointOffIcon from "mdi-react/AccessPointOffIcon";
import AccountCancelOutlineIcon from "mdi-react/AccountCancelOutlineIcon";
import AccountGroupIcon from "mdi-react/AccountGroupIcon";
import AccountOutlineIcon from "mdi-react/AccountOutlineIcon";
import AlertCircleOutlineIcon from "mdi-react/AlertCircleOutlineIcon";
import AlertIcon from "mdi-react/AlertIcon";
import ArchiveIcon from "mdi-react/ArchiveIcon";
import ArchiveOutlineIcon from "mdi-react/ArchiveOutlineIcon";
import ArrowCollapseIcon from "mdi-react/ArrowCollapseIcon";
import ArrowExpandIcon from "mdi-react/ArrowExpandIcon";
import FormatLineSpacingIcon from "mdi-react/FormatLineSpacingIcon";
import ArrowUpLeftIcon from "mdi-react/ArrowUpLeftIcon";
import AutoFixIcon from "mdi-react/AutoFixIcon";
import AutorenewIcon from "mdi-react/AutorenewIcon";
import AwsIcon from "mdi-react/AwsIcon";
import BadgeAccountOutlineIcon from "mdi-react/BadgeAccountOutlineIcon";
import Bell from "mdi-react/BellIcon";
import BellOutlineIcon from "mdi-react/BellOutlineIcon";
import CalendarClockOutlineIcon from "mdi-react/CalendarClockOutlineIcon";
import CalendarIcon from "mdi-react/CalendarIcon";
import CartArrowDownIcon from "mdi-react/CartArrowDownIcon";
import ChartDonutIcon from "mdi-react/ChartDonutIcon";
import CheckIcon from "mdi-react/CheckIcon";
import ChevronDoubleLeftIcon from "mdi-react/ChevronDoubleLeftIcon";
import ChevronDoubleRightIcon from "mdi-react/ChevronDoubleRightIcon";
import ChevronDownIcon from "mdi-react/ChevronDownIcon";
import ChevronLeftIcon from "mdi-react/ChevronLeftIcon";
import ChevronRightIcon from "mdi-react/ChevronRightIcon";
import ChevronUpIcon from "mdi-react/ChevronUpIcon";
import CircleOffOutlineIcon from "mdi-react/CircleOffOutlineIcon";
import CircleOutlineIcon from "mdi-react/CircleOutlineIcon";
import CloseCircleOutlineIcon from "mdi-react/CloseCircleOutlineIcon";
import CloseIcon from "mdi-react/CloseIcon";
import CodeBracesIcon from "mdi-react/CodeBracesIcon";
import CodeJsonIcon from "mdi-react/CodeJsonIcon";
import CodeTagsIcon from "mdi-react/CodeTagsIcon";
import SettingsIcon from "mdi-react/CogOutlineIcon";
import ConnectionIcon from "mdi-react/ConnectionIcon";
import ConsoleLineIcon from "mdi-react/ConsoleLineIcon";
import ContentCopyIcon from "mdi-react/ContentCopyIcon";
import ContentSaveOutlineIcon from "mdi-react/ContentSaveOutlineIcon";
import CropSquareIcon from "mdi-react/CropSquareIcon";
import CubeOutlineIcon from "mdi-react/CubeOutlineIcon";
import CubeSendIcon from "mdi-react/CubeSendIcon";
import DatabaseEditIcon from "mdi-react/DatabaseEditIcon";
import DatabaseIcon from "mdi-react/DatabaseIcon";
import DebugStepOverIcon from "mdi-react/DebugStepOverIcon";
import DeleteAlertOutlineIcon from "mdi-react/DeleteAlertOutlineIcon";
import DeleteOutlineIcon from "mdi-react/DeleteOutlineIcon";
import DeleteRestoreIcon from "mdi-react/DeleteRestoreIcon";
import DeleteSweepOutlineIcon from "mdi-react/DeleteSweepOutlineIcon";
import DevToIcon from "mdi-react/DevToIcon";
import DomainIcon from "mdi-react/DomainIcon";
import DotsHorizontalIcon from "mdi-react/DotsHorizontalIcon";
import DotsVerticalIcon from "mdi-react/DotsVerticalIcon";
import DownloadIcon from "mdi-react/DownloadIcon";
import DragIcon from "mdi-react/DragIcon";
import EmailReceiveOutlineIcon from "mdi-react/EmailReceiveOutlineIcon";
import EmailSendOutlineIcon from "mdi-react/EmailSendOutlineIcon";
import ExclamationThick from "mdi-react/ExclamationThickIcon";
import ExportIcon from "mdi-react/ExportIcon";
import EyeOffOutlineIcon from "mdi-react/EyeOffOutlineIcon";
import EyeOutlineIcon from "mdi-react/EyeOutlineIcon";
import FileClockOutlineIcon from "mdi-react/FileClockOutlineIcon";
import FileCogOutlineIcon from "mdi-react/FileCogOutlineIcon";
import FileImportOutlineIcon from "mdi-react/FileImportOutlineIcon";
import FileOutlineIcon from "mdi-react/FileOutlineIcon";
import FilterOutlineIcon from "mdi-react/FilterOutlineIcon";
import FlashOutlineIcon from "mdi-react/FlashOutlineIcon";
import FolderAccountOutlineIcon from "mdi-react/FolderAccountOutlineIcon";
import FolderMoveOutlineIcon from "mdi-react/FolderMoveOutlineIcon";
import FolderOutlineIcon from "mdi-react/FolderOutlineIcon";
import FolderRemoveOutlineIcon from "mdi-react/FolderRemoveOutlineIcon";
import FolderTableOutlineIcon from "mdi-react/FolderTableOutlineIcon";
import FormTextboxIcon from "mdi-react/FormTextboxIcon";
import FormatAlignRight from "mdi-react/FormatAlignRightIcon";
import ForumIcon from "mdi-react/ForumIcon";
import GitIcon from "mdi-react/GitIcon";
import GoogleIcon from "mdi-react/GoogleIcon";
import GreaterThanIcon from "mdi-react/GreaterThanIcon";
import HandWashOutlineIcon from "mdi-react/HandWashOutlineIcon";
import HelpCircleOutlineIcon from "mdi-react/HelpCircleOutlineIcon";
import HelpIcon from "mdi-react/HelpIcon";
import HistoryIcon from "mdi-react/HistoryIcon";
import ImageBrokenVariantIcon from "mdi-react/ImageBrokenVariantIcon";
import ImageIcon from "mdi-react/ImageIcon";
import InformationOutlineIcon from "mdi-react/InformationOutlineIcon";
import KeyVariantIcon from "mdi-react/KeyVariantIcon";
import KubernetesIcon from "mdi-react/KubernetesIcon";
import LinkVariantIcon from "mdi-react/LinkVariantIcon";
import LockIcon from "mdi-react/LockIcon";
import LockOpenVariantOutlineIcon from "mdi-react/LockOpenVariantOutlineIcon";
import LockOutlineIcon from "mdi-react/LockOutlineIcon";
import LoginVariantIcon from "mdi-react/LoginVariantIcon";
import LogoutVariantIcon from "mdi-react/LogoutVariantIcon";
import MagnifyIcon from "mdi-react/MagnifyIcon";
import MapMarkerIcon from "mdi-react/MapMarkerIcon";
import MemoryIcon from "mdi-react/MemoryIcon";
import MinusIcon from "mdi-react/MinusIcon";
import MonitorDashboardIcon from "mdi-react/MonitorDashboardIcon";
import OpenInNewIcon from "mdi-react/OpenInNewIcon";
import PackageVariantIcon from "mdi-react/PackageVariantIcon";
import PauseIcon from "mdi-react/PauseIcon";
import PencilOutlineIcon from "mdi-react/PencilOutlineIcon";
import PinIcon from "mdi-react/PinIcon";
import PinOffOutlineIcon from "mdi-react/PinOffOutlineIcon";
import PinOutlineIcon from "mdi-react/PinOutlineIcon";
import PlayBoxMultipleIcon from "mdi-react/PlayBoxMultipleIcon";
import PlayIcon from "mdi-react/PlayIcon";
import PlayOutlineIcon from "mdi-react/PlayOutlineIcon";
import PlaySpeedIcon from "mdi-react/PlaySpeedIcon";
import PlusCircleMultipleOutlineIcon from "mdi-react/PlusCircleMultipleOutlineIcon";
import PlusCircleOutlineIcon from "mdi-react/PlusCircleOutlineIcon";
import PlusIcon from "mdi-react/PlusIcon";
import PlusThickIcon from "mdi-react/PlusThickIcon";
import PowershellIcon from "mdi-react/PowershellIcon";
import RefreshIcon from "mdi-react/RefreshIcon";
import RestoreIcon from "mdi-react/RestoreIcon";
import RobotVacuumIcon from "mdi-react/RobotVacuumIcon";
import RotateRightIcon from "mdi-react/RotateRightIcon";
import SafeIcon from "mdi-react/SafeIcon";
import SafeSquareOutlineIcon from "mdi-react/SafeSquareOutlineIcon";
import SecurityIcon from "mdi-react/SecurityIcon";
import SelectIcon from "mdi-react/SelectIcon";
import SendCircleIcon from "mdi-react/SendCircleIcon";
import ShieldAccountOutlineIcon from "mdi-react/ShieldAccountOutlineIcon";
import ShieldKeyOutlineIcon from "mdi-react/ShieldKeyOutlineIcon";
import SkipNextIcon from "mdi-react/SkipNextIcon";
import Snowflake from "mdi-react/SnowflakeIcon";
import SortIcon from "mdi-react/SortIcon";
import CommitIcon from "mdi-react/SourceCommitIcon";
import StarCircleOutlineIcon from "mdi-react/StarCircleOutlineIcon";
import StarIcon from "mdi-react/StarIcon";
import StarOffIcon from "mdi-react/StarOffIcon";
import StarOutlineIcon from "mdi-react/StarOutlineIcon";
import StarPlusOutlineIcon from "mdi-react/StarPlusOutlineIcon";
import StopCircleIcon from "mdi-react/StopCircleIcon";
import SyncIcon from "mdi-react/SyncIcon";
import TagOutlineIcon from "mdi-react/TagOutlineIcon";
import TextBoxOutlineIcon from "mdi-react/TextBoxOutlineIcon";
import TimerSandEmptyIcon from "mdi-react/TimerSandEmptyIcon";
import TimetableIcon from "mdi-react/TimetableIcon";
import ToolsIcon from "mdi-react/ToolsIcon";
import ToyBrickOutlineIcon from "mdi-react/ToyBrickOutlineIcon";
import TuneIcon from "mdi-react/TuneIcon";
import UnarchiveIcon from "mdi-react/UnarchiveIcon";
import UndoIcon from "mdi-react/UndoIcon";
import UpdateIcon from "mdi-react/UpdateIcon";
import UploadIcon from "mdi-react/UploadIcon";
import UploadMultipleIcon from "mdi-react/UploadMultipleIcon";
import UploadOutlineIcon from "mdi-react/UploadOutlineIcon";
import VectorPolyLineIcon from "mdi-react/VectorPolylineIcon";
import ViewColumnOutlineIcon from "mdi-react/ViewColumnOutlineIcon";
import WebIcon from "mdi-react/WebIcon";
import WebhookIcon from "mdi-react/WebhookIcon";
import XmlIcon from "mdi-react/XmlIcon";

// see https://materialdesignicons.com/
export const IconCollection = {
    chevronDown: ChevronDownIcon,
    chevronUp: ChevronUpIcon,
    chevronLeft: ChevronLeftIcon,
    chevronRight: ChevronRightIcon,
    close: CloseIcon,
    closeCircleOutline: CloseCircleOutlineIcon,
    check: CheckIcon,
    plus: PlusIcon,
    minus: MinusIcon,
    plusCircleMultipleOutline: PlusCircleMultipleOutlineIcon,
    deleteOutline: DeleteOutlineIcon,
    deleteRestore: DeleteRestoreIcon,
    deleteAlertOutline: DeleteAlertOutlineIcon,
    deleteSweepOutline: DeleteSweepOutlineIcon,
    folderMoveOutlineIcon: FolderMoveOutlineIcon,
    imageBrokenVariant: ImageBrokenVariantIcon,
    play: PlayIcon,
    playOutline: PlayOutlineIcon,
    playSpeedIcon: PlaySpeedIcon,
    playBoxMultiple: PlayBoxMultipleIcon,
    pause: PauseIcon,
    informationOutline: InformationOutlineIcon,
    circleOffOutline: CircleOffOutlineIcon,
    magnify: MagnifyIcon,
    pencilOutline: PencilOutlineIcon,
    star: StarIcon,
    starOutline: StarOutlineIcon,
    starOff: StarOffIcon,
    starPlusOutline: StarPlusOutlineIcon,
    starCircleOutline: StarCircleOutlineIcon,
    calendar: CalendarIcon,
    calendarClockOutline: CalendarClockOutlineIcon,
    timerSandEmpty: TimerSandEmptyIcon,
    chartDonut: ChartDonutIcon,
    lockOutline: LockOutlineIcon,
    lockOpenVariantOutline: LockOpenVariantOutlineIcon,
    accountOutline: AccountOutlineIcon,
    shieldAccountOutline: ShieldAccountOutlineIcon,
    upload: UploadIcon,
    uploadOutline: UploadOutlineIcon,
    folderOutline: FolderOutlineIcon,
    circleOutline: CircleOutlineIcon,
    eyeOutline: EyeOutlineIcon,
    eyeOffOutline: EyeOffOutlineIcon,
    bellOutline: BellOutlineIcon,
    bell: Bell,
    logoutVariant: LogoutVariantIcon,
    key: KeyVariantIcon,
    filterOutline: FilterOutlineIcon,
    sort: SortIcon,
    cubeOutline: CubeOutlineIcon,
    cubeSend: CubeSendIcon,
    alertCircleOutline: AlertCircleOutlineIcon,
    image: ImageIcon,
    saveOutline: ContentSaveOutlineIcon,
    accountCancelOutline: AccountCancelOutlineIcon,
    codeTags: CodeTagsIcon,
    tagOutline: TagOutlineIcon,
    git: GitIcon,
    tune: TuneIcon,
    sync: SyncIcon,
    folderTableOutline: FolderTableOutlineIcon,
    folderRemoveOutline: FolderRemoveOutlineIcon,
    memory: MemoryIcon,
    domain: DomainIcon,
    loginVariation: LoginVariantIcon,
    fileOutline: FileOutlineIcon,
    flashOutline: FlashOutlineIcon,
    connection: ConnectionIcon,
    safeSquareOutline: SafeSquareOutlineIcon,
    webhook: WebhookIcon,
    monitorDashboard: MonitorDashboardIcon,
    dotsHorizontal: DotsHorizontalIcon,
    dotsVertical: DotsVerticalIcon,
    archiveOutline: ArchiveOutlineIcon,
    archive: ArchiveIcon,
    unarchive: UnarchiveIcon,
    export: ExportIcon,
    toyBrickOutline: ToyBrickOutlineIcon,
    download: DownloadIcon,
    badge: BadgeAccountOutlineIcon,
    helpCircleOutline: HelpCircleOutlineIcon,
    helpIcon: HelpIcon,
    devTo: DevToIcon,
    emailSendOutline: EmailSendOutlineIcon,
    arrowUpLeft: ArrowUpLeftIcon,
    rotateRight: RotateRightIcon,
    fileClockOutline: FileClockOutlineIcon,
    shieldKeyOutline: ShieldKeyOutlineIcon,
    history: HistoryIcon,
    pin: PinIcon,
    pinOutline: PinOutlineIcon,
    pinOffOutline: PinOffOutlineIcon,
    openInNew: OpenInNewIcon,
    packageVariant: PackageVariantIcon,
    arrowExpand: ArrowExpandIcon,
    arrowCollapse: ArrowCollapseIcon,
    formatLineSpacing: FormatLineSpacingIcon,
    fileImportOutline: FileImportOutlineIcon,
    skipNext: SkipNextIcon,
    fileCogOutline: FileCogOutlineIcon,
    aws: AwsIcon,
    google: GoogleIcon,
    emailReceiveOutline: EmailReceiveOutlineIcon,
    kubernetes: KubernetesIcon,
    accountGroup: AccountGroupIcon,
    powershell: PowershellIcon,
    web: WebIcon,
    contentCopy: ContentCopyIcon,
    handWashOutline: HandWashOutlineIcon,
    database: DatabaseIcon,
    safe: SafeIcon,
    xml: XmlIcon,
    consoleLine: ConsoleLineIcon,
    vacuum: RobotVacuumIcon,
    codeBraces: CodeBracesIcon,
    codeJson: CodeJsonIcon,
    timetable: TimetableIcon,
    viewColumnOutline: ViewColumnOutlineIcon,
    settingsIcon: SettingsIcon,
    link: LinkVariantIcon,
    alignRight: FormatAlignRight,
    cartArrowDown: CartArrowDownIcon,
    autoFix: AutoFixIcon,
    autorenew: AutorenewIcon,
    restore: RestoreIcon,
    mapMarker: MapMarkerIcon,
    folderAccountOutline: FolderAccountOutlineIcon,
    debugStepOver: DebugStepOverIcon,
    formTextbox: FormTextboxIcon,
    drag: DragIcon,
    objectTemplate: SelectIcon,
    customObject: CropSquareIcon,
    textBoxOutline: TextBoxOutlineIcon,
    security: SecurityIcon,
    refresh: RefreshIcon,
    lock: LockIcon,
    plusThick: PlusThickIcon,
    exclamationThick: ExclamationThick,
    snowFlake: Snowflake,
    databaseEdit: DatabaseEditIcon,
    vectorPolyLine: VectorPolyLineIcon,
    undo: UndoIcon,
    uploadMultiple: UploadMultipleIcon,
    commit: CommitIcon,
    alert: AlertIcon,
    update: UpdateIcon,
    plusCircleOutline: PlusCircleOutlineIcon,
    sendCircle: SendCircleIcon,
    greaterThan: GreaterThanIcon,
    tools: ToolsIcon,
    chevronDoubleLeft: ChevronDoubleLeftIcon,
    chevronDoubleRight: ChevronDoubleRightIcon,
    forum: ForumIcon,
    stopCircle: StopCircleIcon,
    accessPoint: AccessPointIcon,
    accessPointOff: AccessPointOffIcon,
};
